import { QuoQuestLevelStage } from "../types/quest";
import moment from "moment/moment";
import { IonButton, IonIcon } from "@ionic/react";
import { flag, lockClosed, play } from "ionicons/icons";
import React, { useEffect, useState } from "react";
import { useQuestsStore } from "../stores/quests.store";

const QuoQuestLevelStageCard = ({
  level,
  stage,
  stageIndex
}: {
  level: number;
  stage: QuoQuestLevelStage;
  stageIndex: number;
}) => {
  const updateStage = useQuestsStore(state => state.updateLevelStage);
  const [diff, setDiff] = useState(
    stage.lockedUntil ? moment(stage.lockedUntil).diff(moment()) : 1
  );

  useEffect(() => {
    const intervalRef = setInterval(() => {
      if (stage.lockedUntil) {
        const newDiff = moment(stage.lockedUntil).diff(moment());
        setDiff(newDiff);

        if (newDiff <= 0) {
          // Update the state
          updateStage(level, { ...stage, attemptsLeft: 3, lockedUntil: null });
        }
      }
    }, 1000);
    return () => clearInterval(intervalRef);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stage]);

  const getAttemptsElement = () => {
    if (stage.attemptsLeft === 0 && stage.lockedUntil) {
      return (
        <div className="h-fit rounded-[0.25rem] px-2 py-1 bg-error flex items-center justify-center gap-2 text-primary-80">
          <IonIcon icon={lockClosed} className="text-sm" />
          <span>{moment.utc(diff).format("HH:mm:ss")}</span>
        </div>
      );
    }
    const bgColor = stage.attemptsLeft === 3 ? "bg-success" : "bg-[#fbff0a]";
    return (
      <div className="h-fit rounded-[0.25rem] px-2 py-1 bg-primary-80 flex items-center justify-center gap-2 text-primary-30">
        Attempts Left
        <div
          className={`h-fit rounded-sm text-primary-80 px-1 text-sm ${bgColor}`}
        >
          {stage.attemptsLeft}
        </div>
      </div>
    );
  };

  return (
    <div className="rounded-lg bg-primary-60 text-white flex flex-col overflow-hidden text-left">
      <div className="flex justify-between items-center m-4">
        <div className="font-bold text-lg flex flex-col">
          <span>
            <IonIcon icon={play} className="text-sm" />{" "}
            {moment(stage.marketDateFrom).format("DD MMM YYYY")}
          </span>
          <span>
            <IonIcon icon={flag} className="text-sm" />{" "}
            {moment(stage.marketDateTo).format("DD MMM YYYY")}
          </span>
        </div>
        {getAttemptsElement()}
      </div>
      <div className="bg-primary-80 px-4 py-1 uppercase text-xs text-primary-40">
        <span>Market</span>
        <span className="fixed left-36">Feature Unlock</span>
      </div>
      <div className="px-4 py-1 text-xs font-semibold">
        <span className="text-error">{stage.marketType}</span>
        <span className="fixed left-36">{stage.featureUnlock}</span>
      </div>
      <div className="bg-primary-80 p-4 flex flex-col">
        {stage.attemptsLeft === 0 && stage.lockedUntil ? (
          <>
            <span className="text-base font-semibold mb-2 text-error">
              Stage Locked:
            </span>
            <p className="whitespace-pre-wrap text-primary-20 text-sm mb-4">
              You’ve used up your 3 allocated trade attempts. We’ll notify you
              when the task is available for trading!
            </p>
          </>
        ) : (
          <>
            <span className="text-base font-semibold mb-2">Your Mission:</span>
            <p className="whitespace-pre-wrap text-primary-20 text-sm mb-4">
              {stage.description}
            </p>
          </>
        )}
        <IonButton
          color="primary"
          className="h-16 text-base"
          expand="block"
          disabled={!!(stage.attemptsLeft === 0 && stage.lockedUntil)}
          routerLink={`/quest/levels/${level}/${stageIndex}/bot`}
          // routerLink={`/quest/levels/${level}/${stage.stageId}/bot`}
        >
          Set Strategy
        </IonButton>
      </div>
    </div>
  );
};
export default QuoQuestLevelStageCard;
